import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'uniqueSlots',
    standalone: false
})
export class UniqueSlotsPipe implements PipeTransform {

  transform(slots: any[], key: string = 'slotTime'): any[] {
    if (!slots || !Array.isArray(slots)) {
      return [];
    }

    // Use a Set to filter out duplicates based on the key
    const unique = new Map();
    slots.forEach(slot => {
      const value = slot[key];
      if (!unique.has(value)) {
        unique.set(value, slot);
      }
    });

    // Return only unique values
    return Array.from(unique.values());
  }
}